import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  root: {},
  errorUnderline: {
    width: '100%',
    height: '2px',
    background: '#f44336',
  },
  checkbox: {
    '& .MuiIconButton-label': {
      position: 'relative',
      zIndex: 0,
      '&:after': {
        content: '""',
        left: 4,
        top: 4,
        height: 15,
        width: 15,
        position: 'absolute',
        backgroundColor: palette.common.white,
        zIndex: -1,
      },
    },
  },
  checkboxAlert: {
    color: custom.status.danger.contrastText,
  },
  checkboxHighlighted: {
    color: palette.primary.main,
  },
  control: {
    width: '100%',
    margin: 0,
    marginLeft: -11,
  },
  controlNoCepik: {
    width: '100%',
    margin: 0,
    marginLeft: -11,
  },
  expand: {
    textDecoration: 'underline',
    '&:hover': {
      color: palette.primary.main,
    },
  },
  required: {
    color: custom.status.danger.contrastText,
    fontSize: 14,
    position: 'absolute',
    bottom: 6,
  },
  label: {
    fontSize: 13,
    color: custom.grey[2],
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    whiteSpace: 'pre-line',
    '& a': {
      color: 'inherit',
    },
    '& a:hover': {
      color: palette.primary.main,
    },
  },
  alert: {},
  consentRequired: {
    fontSize: 16,
    lineHeight: '13px',
    color: palette.primary.main,
  },
  infoBox: {
    fontSize: 13,
    borderRadius: 5,
    border: `solid 2px ${palette.primary.main}`,
    margin: '10px 0',
    width: '100%',
  },
  borderBox: {
    border: `solid 2px ${palette.primary.main}`,
  },

  title: {
    fontWeight: 'bold',
  },
  marketingInfoBox: {
    marginBottom: 0,
    fontSize: 14,
    padding: '15px',
  },
}));
